import { Appearance } from "@stripe/stripe-js";

const stripeElementsTheme: Appearance =  {
    theme: "stripe",
    variables: {
      colorPrimary: "#073937",
      colorBackground: "#fffbf2",
      colorText: "#073937",
      colorDanger: "#df1b41",
      fontFamily: "GT-America-Standard-Light, Helvetica, Arial, sans-serif",
      spacingGridColumn: "15px",
      spacingGridRow: "24px",
      fontSizeBase: "13px",
      borderRadius: "10px",
      colorTextPlaceholder: "#c1bfb9",
    },
    rules: {
      ".Input": {
        border: "1px solid #c1bfb9",
        padding: "14px",
        colorTextPlaceholder: "#c1bfb9",
      },
      ".Label": {
        marginBottom: "12px",
      },
      ".Input:focus": {
        outline: "none",
        border: "thin solid #073937",
      },
      ".Input:hover": {
        backgroundColor: "#f8f3eb",
      },
      ".Tab": {
        padding: "10px 12px 8px 12px",
        marginLeft: "12px",
        border: "thin solid rgba(0,0,0,.2)",
      },
      ".Tab:hover": {
        border: "thin solid rgba(0,0,0,.2)",
        backgroundColor: "#f8f3eb",
        boxShadow:
          "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
      },
      ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {
        border: "thin solid #073937",
        backgroundColor: "#f8f3eb",
        boxShadow:
          "0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
      },
    },
  };

  export default stripeElementsTheme;